import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import { overrideTailwindClasses } from 'tailwind-override';

type Color = 'white' | 'black';

const BG_COLOR_CLASSES: Record<Color, string> = {
  white: 'bg-white',
  black: 'bg-hrg-black-90 text-white',
};

interface Props {
  className?: string;
  color?: Color;
  children: ReactNode;
}

export const SimpleCard: FC<Props> = ({
  className,
  children,
  color = 'white',
}) => (
  <div
    className={overrideTailwindClasses(
      clsx('p-6 rounded-5xl', BG_COLOR_CLASSES[color], className)
    )}
  >
    {children}
  </div>
);
